<template>
  <section class="section is-medium bg-gradient-pastel">
    <div class="container">
      <div class="has-text-centered mb-6">
        <h2 class="title is-2 has-line animate fade-in-up">
          {{ $t('landing.features-title') }}
        </h2>
      </div>
      
      <div class="columns is-multiline mt-5">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="column is-6 mb-5"
        >
          <FeatureItem 
            :title="$t(feature.title)"
            :description="$t(feature.description)"
            :icon-name="feature.icon"
            :icon-class="feature.iconClass"
            :animation-class="getAnimationClass(index)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import FeatureItem from './FeatureItem.vue';

const features = [
  {
    title: 'landing.feature-worldwide',
    description: 'landing.feature-worldwide-description',
    icon: 'fas fa-globe',
    iconClass: 'has-text-indiefy-blue',
  },
  {
    title: 'landing.feature-analytics',
    description: 'landing.feature-analytics-description',
    icon: 'fas fa-chart-line',
    iconClass: 'has-text-indiefy-teal',
  },
  {
    title: 'landing.feature-royalties',
    description: 'landing.feature-royalties-description',
    icon: 'fas fa-wallet',
    iconClass: 'has-text-indiefy-pink',
  },
  {
    title: 'landing.feature-rights',
    description: 'landing.feature-rights-description',
    icon: 'fas fa-certificate',
    iconClass: 'has-text-indiefy-lavender',
  },
];

const getAnimationClass = (index) => {
  const isLeft = index % 2 === 0;
  const delay = index > 1 ? ' animate--delay-1' : '';
  return `animate ${isLeft ? 'slide-in-left' : 'slide-in-right'}${delay}`;
};
</script>

<style scoped lang="scss">
@import "@/styles/abstracts/colors";

.bg-gradient-pastel {
  background: linear-gradient(135deg, 
    rgba(lighten($indiefy-blue, 35%), 0.6) 0%, 
    rgba(lighten($indiefy-lavender, 20%), 0.6) 50%, 
    rgba(lighten($indiefy-teal, 40%), 0.6) 100%
  );
  
  .body--dark & {
    background: linear-gradient(135deg, 
      rgba(darken($indiefy-blue, 15%), 0.4) 0%, 
      rgba(darken($indiefy-lavender, 10%), 0.4) 50%, 
      rgba(darken($indiefy-teal, 15%), 0.4) 100%
    );
  }
}

.title.has-line {
  position: relative;
  padding-bottom: 1.5rem;
  color: var(--color-text, #000);
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, $indiefy-blue, $indiefy-pink);
    border-radius: 2px;
  }
}
</style>